import logger from "Libs/logger";
import { createAppAsyncThunk } from "Store/createAppAsyncThunk";
import { updateEnvironmentVariableRequest } from "Api/variables/environment/updateEnvironmentVariable.request";
import { pickFromFields } from "Api/utils";
import { modifiableEnvironmentVariableFields } from "Api/variables/environment/constants";
import type { Variable } from "Api/variables/environment/types";

export type EnvironmentVariableData = {
  id: string;
  name: string;
  value: string;
  is_json: boolean;
  is_enabled: boolean;
  is_inheritable: boolean;
  is_sensitive: boolean;
  visible_build: boolean;
  visible_runtime: boolean;
  application_scope: string[] | undefined;
};

type UpdateEnvironmentVariableThunkPropType = {
  environmentId: string;
  projectId: string;
  organizationId: string;
  variable: Variable;
  data: EnvironmentVariableData;
};

export const updateVariable = createAppAsyncThunk(
  "app/project/environment/variable/update",
  async (
    props: UpdateEnvironmentVariableThunkPropType,
    { rejectWithValue }
  ) => {
    const { environmentId, projectId, variable, data } = props;
    const fields = Object.assign(
      {},
      { projectId, environmentId },
      { variableId: variable.id },
      data
    );

    const pickedData = pickFromFields(fields, [
      ...modifiableEnvironmentVariableFields
    ]);

    try {
      const updatedVariable = await updateEnvironmentVariableRequest({
        variable,
        fields: pickedData
      });
      return updatedVariable?._embedded.entity;
    } catch (err: any) {
      logger(err, {
        environmentId,
        projectId,
        action: "environmentUpdateVariable",
        variable,
        data
      });
      return rejectWithValue({ error: err.message });
    }
  },
  {
    condition: ({ variable }) => {
      return !!variable?._links?.["#edit"]?.href;
    }
  }
);
